import { render, staticRenderFns } from "./DataRelease.vue?vue&type=template&id=307bf27c&scoped=true&"
import script from "./DataRelease.vue?vue&type=script&lang=js&"
export * from "./DataRelease.vue?vue&type=script&lang=js&"
import style0 from "./DataRelease.vue?vue&type=style&index=0&id=307bf27c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307bf27c",
  null
  
)

export default component.exports